import React, { useState } from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu"; // Using Radix UI as base for Shadcn
import { Button } from "../ui/button";
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { isA23 } from "@/src/colors/baseColors";

const DropdownMenuRoot = DropdownMenu.Root;
export const CustomDropdownButton = ({
  selectedDropdownId,
  setSelectedDropdownId,
  dropdownItems,
}) => {
  // State to hold the current label of the dropdown button
  const [selectedLabel, setSelectedLabel] = useState(
    dropdownItems.find((item) => item.id === selectedDropdownId)?.label ||
      "Select"
  );

  // Function to handle item selection
  const handleSelect = (label, id) => {
    setSelectedLabel(label);
    setSelectedDropdownId(id);
  };

  return (
    <DropdownMenuRoot>
      <DropdownMenuTrigger asChild>
        <Button
          className={`flex items-center gap-2 rounded-sm border-1 border-(--color-b-surface) bg-foreground text-primary text-xs font-medium shadow-lg focus-visible:ring-0 transition-colors w-full ${
            isA23 ? "px-2 py-1.5" : "rounded-4xl py-1.5 px-3"
          }`}
        >
          {selectedLabel}
          {/* Simple SVG for a chevron down icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-down w-5 h-5 text-gray-400"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56 bg-foreground text-secondary rounded-lg shadow-xl mt-2 mx-2">
        {/* Map through dropdownItems to create menu items */}
        {dropdownItems.map((item) => (
          <DropdownMenuItem
            key={item.id}
            className="cursor-pointer px-4 py-2 hover:bg-gray-100 rounded-lg"
            onSelect={() => handleSelect(item.label, item.id)}
          >
            {item.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenuRoot>
  );
};
